import { getBrandNamesList } from "../actions/BrandAction";
import { getAllProductIds } from "../actions/ProductAction";
import "react-toastify/dist/ReactToastify.css";

export const PRODUCTLIST = [];
export const BRANDLIST = [];
export const OPERATORLIST = [];

let productPage = 1;
let productTotalPages = 1;
let productLoading = false;

export const resetProductList = () => {
  PRODUCTLIST.length = 0;
  productPage = 1;
  productTotalPages = 1;
  productLoading = false;
};

export const loadProductList = async (page = 1, limit = 10) => {
  if (productLoading || (page > 1 && page > productTotalPages)) return;

  productLoading = true;
  try {
    const result = await getAllProductIds({ page, limit });
    const products = result.products || result || [];
    productTotalPages = result.totalPages || 1;

    if (page === 1) PRODUCTLIST.length = 0;

    // Remove trailing "International Reload" if already added
    const intlIndex = PRODUCTLIST.findIndex((p) => p.id === "international");
    if (intlIndex !== -1) PRODUCTLIST.splice(intlIndex, 1);

    PRODUCTLIST.push(...products);

    // Always append International Reload at the end
    if (page >= productTotalPages) {
      PRODUCTLIST.push({ id: "international", name: "International Reload" });
    }

    productPage = page;
  } finally {
    productLoading = false;
  }
};

export const loadMoreProducts = async (limit = 10) => {
  if (productLoading || productPage >= productTotalPages) return;
  await loadProductList(productPage + 1, limit);
};

export const isProductListFullyLoaded = () => productPage >= productTotalPages;

export const loadBrandList = async () => {
  const result = await getBrandNamesList();
  BRANDLIST.length = 0;
  if (Array.isArray(result.brands)) {
    BRANDLIST.push(...result.brands);
  }
};


